import axios from "axios";
import { API_V3_URL } from "@/constants/constants";

const state = {
    data: {},
};

const mutations = {
    SET_DADOS(state, data) {
        state.data = data;
    },
};

const actions = {
    async fetchDados({ commit }) {
        try {
            const response = await axios.get(`${API_V3_URL}/external/label/themes`);
            commit("SET_DADOS", response.data);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    },
};

export default {
    state,
    mutations,
    actions,
};
